export default {"src":"https://fishbrain.com/_next/static/media/dC.d36b0ac4.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};